const env = process.env.NODE_ENV || 'production'
// 线上
const baseApi = '//api.xueersi.com/scorpioapi/summercampaign'
const mockApi = 'http://yapi.xesv5.com/mock/915'
// 是否启用 mock
const mock = false

const config = {
  development: {
    baseApi,
    mockApi,
  },
  test: {
    baseApi,
    mockApi,
  },
  production: {
    baseApi,
  },
}

export default {
  env,
  mock,
  ...config[env],
}
